import { useTranslation } from 'react-i18next'

import { PaymentStatus } from '../../../../types/payment/payment'
import { RefundStatus } from '../../../../types/booking/booking'

interface PaymentBadgeProps {
  status: PaymentStatus
}

export const PaymentStatusBadge = ({ status }: PaymentBadgeProps) => {
  const { t } = useTranslation('payments')

  switch (status) {
    case PaymentStatus.SUCCESS:
      return (
        <span className="badge badge-success">
          <span
            className="dot-status"
            style={{ background: 'var(--ph-success)' }}
          />
          {t('payments.payment-status.success')}
        </span>
      )

    case PaymentStatus.AUTHORIZED:
      return (
        <span className="badge badge-info">
          {t('payments.payment-status.authorized')}
        </span>
      )

    case PaymentStatus.REFUNDED:
      return (
        <span className="badge badge-secondary">
          {t('payments.payment-status.refunded')}
        </span>
      )

    case PaymentStatus.PAYMENT_PENDING:
      return (
        <span className="badge badge-warning">
          {t('payments.payment-status.payment_pending')}
        </span>
      )

    case PaymentStatus.FAILED:
      return (
        <span className="badge badge-danger">
          {t('payments.payment-status.failed')}
        </span>
      )

    case PaymentStatus.CANCELED:
      return (
        <span className="badge badge-danger">
          {t('payments.payment-status.canceled')}
        </span>
      )

    case PaymentStatus.EXPIRED:
      return (
        <span className="badge badge-secondary">
          {t('payments.payment-status.expired')}
        </span>
      )

    default:
      return null
  }
}

const REFUND_BADGES: Record<RefundStatus, string> = {
  [RefundStatus.PENDING]: 'badge-warning',
  [RefundStatus.PROCESSING]: 'badge-warning',
  [RefundStatus.SUCCEEDED]: 'badge-secondary',
  [RefundStatus.FAILED]: 'badge-danger',
}

/** Automatic refund (or released authorisation) of a payment that could not be honoured. */
export const RefundStatusBadge = ({ status }: { status: RefundStatus }) => {
  const { t } = useTranslation('payments')
  return (
    <span className={`badge ${REFUND_BADGES[status]}`}>
      {t(`payments.refund-status.${status.toLowerCase()}`)}
    </span>
  )
}
